import { createSelector } from 'reselect';
import * as root from '../';
import * as fromDepartmentField from './department-field.reducer';

export const getDepartmentFieldState = (state: root.State) => state.departmentField;
export const getDepartmentFieldEntities = createSelector(getDepartmentFieldState, fromDepartmentField.getEntities);

